var map = {
	"./de.svg": "7e20",
	"./el.svg": "d90d",
	"./en.svg": "ebb2",
	"./es.svg": "2bcf",
	"./fr.svg": "4b32",
	"./he.svg": "9950",
	"./tr.svg": "475f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";